import reservationService from '@/services/reservationService';
import { fetchTemplate } from '@/utils/isServer';
import dayjs from 'dayjs';

interface IData {
  data: object;
  time: number;
}

let map: Map<string, IData>;
if (global.mapHolder) {
  map = global.mapHolder;
} else {
  map = new Map<string, IData>();
  global.mapHolder = map;
}

const MAX_CACHE = 1000 * 60 * 5; // 5 minutos de cace

export const clearCache = () => {
  map.clear();
};


export const fetchComputePrice = async (
  baseUrl: string,
  facility_id: number,
  facility_url_code: string,
  facilityParkingType?: number
): Promise<any> => {
  const num_days = 2;
  const start_num_days = 1;
  /*
  if (facilityParkingType === 0 || facilityParkingType === 1) {
    num_days = 8;
    start_num_days = 1;
  }
  if (facilityParkingType === 2) {
    num_days = 6;
  }
 */
  const date: number = new Date().getTime();
  const vcheckin = dayjs().add(start_num_days, 'day').format('YYYY-MM-DD');

  const vcheckout = dayjs().add(num_days, 'day').format('YYYY-MM-DD');
  const cp_key = `cp_${facility_id}_${vcheckin}_${vcheckout}`;
  const data: IData = map.get(cp_key);
  if (data && data.time && date - data.time < MAX_CACHE) {
    return data.data;
  }

  const searchData = {
    facility_id: facility_id,
    facility_url_code: facility_url_code,
    baseUrl: baseUrl
  };

  const priceDescription = await reservationService.GetPrice(
    searchData,
    null,
    vcheckin,
    vcheckout
  );
  map.set(cp_key, {
    time: date,
    data: priceDescription,
  });
  return await priceDescription;
};


export const fetchSearchAlternate = async (
  baseUrl: string,
  airport_id: number,
  checkin: any,
  checkout: any,
  lat?: any,
  lng?: any,
  airport_display_type?: number
): Promise<any> => {
  let num_days = 1;
  let start_num_days = 0;
  if (airport_display_type === 0) {
    num_days = 8;
    start_num_days = 1;
  }
  if (airport_display_type === 2) {
    num_days = 5;
  }
  const date: number = new Date().getTime();
  const vcheckin = checkin
    ? dayjs(checkin).format('YYYY-MM-DD')
    : dayjs().add(start_num_days, 'day').format('YYYY-MM-DD');

  const vcheckout = checkout
    ? dayjs(checkout).format('YYYY-MM-DD')
    : dayjs().add(num_days, 'day').format('YYYY-MM-DD');
  const sa_key = `sa_${airport_id}_${vcheckin}_${vcheckout}_${lat}_${lng}`;
  const data: IData = map.get(sa_key);
  if (data && data.time && date - data.time < MAX_CACHE) {
    return data.data;
  }

  const searchData = {
    airport_id: airport_id,
    lower_selling_price: 0,
    higher_selling_price: 0,
    lower_distance_terminal: 0,
    higher_distance_terminal: 0,
    rating: 0,
    start_date: vcheckin,
    end_date: vcheckout,
    latitude: lat,
    longitude: lng,
    order: 0,
  };
  if (lat || lng) {
    searchData['address'] = 1;
  }

  const searchResponse = await fetch(
    `${baseUrl}/api/Facility/SearchAlternate`,
    {
      ...fetchTemplate,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(searchData),
    }
  );

  const response = searchResponse.json();
  map.set(sa_key, {
    time: date,
    data: response,
  });
  return await response;
};

export const cacheFetch = async (url: string, text = false): Promise<any> => {
  const date: number = new Date().getTime();
  const data: IData = map.get(url);
  if (data && data.time && date - data.time < MAX_CACHE) {
    return data.data;
  }

  const req = await fetch(url, { ...fetchTemplate });

  if (req.status != 200) {
    return {};
  }
  const response = text ? await req.text() : await req.json();
  map.set(url, {
    time: date,
    data: response,
  });
  return response;
};

export const cacheFetchTimeout = async (url: string, text = false, timeout = 5000): Promise<any> => {
  const date: number = new Date().getTime();
  const data: IData = map.get(url);
  if (data && data.time && date - data.time < MAX_CACHE) {
    return data.data;
  }

  const req = await fetch(url, { ...fetchTemplate,
        signal: (AbortSignal as any).timeout(timeout) 
   });

  if (req.status != 200) {
    return {};
  }
  const response = text ? await req.text() : await req.json();
  map.set(url, {
    time: date,
    data: response,
  });
  return response;
};

